import {
  Home,
  MessageSquare,
  Calendar,
  UserCheck,
  Users,
  Microscope,
  Stethoscope,
  ShieldCheck,
  UserCog,
  Settings,
  FileText,
  FileSignature,
  Zap,
  Wallet,
  Banknote,
  Receipt,
  Landmark,
  HandCoins,
  Coins,
  Truck,
  ClipboardList,
  LifeBuoy,
  Hourglass,
  BadgeCheck,
  type LucideIcon,
} from 'lucide-react';
import type { ModuleKey } from '../shared/types/license';

export type NavItem = {
  id: string;
  label: string;
  to: string;
  icon: LucideIcon;
  permission?: string; // checado quando usePermissions chegar (Fase 1B)
  anyPermission?: string[]; // visível se tiver QUALQUER uma destas
  requireProfessional?: boolean; // ocultar se userDoc.professionalId for null/undefined
  module?: ModuleKey; // oculto quando a licenca da clinica (enforced) nao inclui o modulo
};

export type NavGroup = {
  id: string;
  label: string;
  items: NavItem[];
};

/**
 * Estrutura completa do menu — itens são gateados por permissão na
 * Fase 1B (usePermissions). Por ora todos aparecem se logado,
 * mas a maioria leva a rotas que ainda não existem (vão dar 404).
 */
export const NAV_GROUPS: readonly NavGroup[] = [
  {
    id: 'home',
    label: '',
    items: [{ id: 'home', label: 'Início', to: '/', icon: Home }],
  },
  {
    id: 'comunicacao',
    label: 'Comunicação',
    items: [
      { id: 'whatsapp', label: 'WhatsApp', to: '/whatsapp', icon: MessageSquare, permission: 'VIEW_WHATSAPP', module: 'whatsapp' },
      { id: 'automations', label: 'Automações', to: '/automations', icon: Zap, permission: 'MANAGE_AUTOMATIONS', module: 'whatsapp' },
    ],
  },
  {
    id: 'operacao',
    label: 'Operação',
    items: [
      { id: 'schedule', label: 'Agenda', to: '/schedule', icon: Calendar, permission: 'VIEW_SCHEDULE', module: 'agenda' },
      { id: 'waitlist', label: 'Lista de espera', to: '/waitlist', icon: Hourglass, permission: 'MANAGE_WAITLIST', module: 'lista_espera' },
      { id: 'my-schedule', label: 'Minha agenda', to: '/my-schedule', icon: UserCheck, requireProfessional: true, module: 'agenda' },
      { id: 'reports', label: 'Relatórios', to: '/reports', icon: FileText, permission: 'VIEW_SCHEDULE', module: 'agenda' },
      { id: 'laudos', label: 'Laudos', to: '/laudos', icon: ClipboardList, permission: 'VIEW_LAUDO', module: 'laudos' },
      { id: 'consents', label: 'Termos', to: '/termos', icon: FileSignature, permission: 'VIEW_PATIENTS', module: 'whatsapp' },
    ],
  },
  {
    id: 'financeiro',
    label: 'Financeiro',
    items: [
      { id: 'financial', label: 'Painel', to: '/dashboards/financial', icon: Wallet, permission: 'VIEW_FINANCIAL', module: 'financeiro' },
      { id: 'finance-caixa', label: 'Caixa', to: '/financeiro/caixa', icon: Banknote, permission: 'VIEW_FINANCIAL', module: 'financeiro' },
      { id: 'finance-receber', label: 'A receber', to: '/financeiro/receber', icon: Receipt, permission: 'VIEW_FINANCIAL', module: 'financeiro' },
      { id: 'finance-pagar', label: 'A pagar', to: '/financeiro/pagar', icon: HandCoins, permission: 'VIEW_FINANCIAL', module: 'financeiro' },
      { id: 'finance-repasse', label: 'Repasse médico', to: '/financeiro/repasse', icon: Coins, permission: 'VIEW_FINANCIAL', module: 'financeiro' },
      { id: 'finance-fornecedores', label: 'Fornecedores', to: '/financeiro/fornecedores', icon: Truck, permission: 'VIEW_FINANCIAL', module: 'financeiro' },
      { id: 'finance-contas', label: 'Contas', to: '/financeiro/contas', icon: Landmark, permission: 'VIEW_FINANCIAL', module: 'financeiro' },
    ],
  },
  {
    id: 'cadastros',
    label: 'Cadastros',
    items: [
      { id: 'patients', label: 'Pacientes', to: '/patients', icon: Users, permission: 'VIEW_PATIENTS' },
      { id: 'exams', label: 'Exames', to: '/exams', icon: Microscope, permission: 'VIEW_EXAMS' },
      {
        id: 'professionals',
        label: 'Profissionais',
        to: '/professionals',
        icon: Stethoscope,
        permission: 'MANAGE_PROFESSIONALS',
      },
    ],
  },
  {
    id: 'sistema',
    label: 'Sistema',
    items: [
      {
        id: 'users',
        label: 'Usuários',
        to: '/users',
        icon: UserCog,
        permission: 'MANAGE_USERS',
      },
      {
        id: 'roles',
        label: 'Perfis',
        to: '/roles',
        icon: ShieldCheck,
        permission: 'MANAGE_ROLES',
      },
      {
        id: 'audit',
        label: 'Auditoria',
        to: '/audit',
        icon: FileText,
        permission: 'VIEW_AUDIT_LOGS',
      },
      { id: 'support', label: 'Suporte', to: '/support', icon: LifeBuoy, anyPermission: ['OPEN_SUPPORT_TICKET', 'MANAGE_SUPPORT_TICKETS'] },
      { id: 'subscription', label: 'Assinatura', to: '/assinatura', icon: BadgeCheck, permission: 'MANAGE_SYSTEM_SETTINGS' },
      { id: 'invoices', label: 'Faturas', to: '/faturas', icon: Receipt, permission: 'MANAGE_SYSTEM_SETTINGS' },
      {
        id: 'settings',
        label: 'Configurações',
        to: '/settings',
        icon: Settings,
        permission: 'MANAGE_SYSTEM_SETTINGS',
      },
    ],
  },
];
